import React from 'react'

import flagPoster from '../assets/videos/flag-poster.jpg'
import flagVideo from '../assets/videos/flag.mp4'

const FlagVideo = props => (
  <div css={{ width: '100%', height: '100%' }} {...props}>
    <video
      autoPlay
      playsInline
      loop
      muted
      poster={flagPoster}
      src={flagVideo}
      css={{
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center top',
      }}
    />
  </div>
)

export default FlagVideo
